const cookiesLinks = document.querySelectorAll('a[href="#ustawienia-ciasteczek"]');
if (cookiesLinks?.length > 0) {
  cookiesLinks.forEach((cookiesLink) => {
    cookiesLink.addEventListener('click', (e) => {
      e.preventDefault(); // prevent url change
      const revokeButton = document.querySelector('.cc-revoke');
      if (revokeButton) {
        revokeButton.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
      }
    });
  });
}
